import { GridLoadingState } from '@/components';
import { useInfiniteScroll } from '@/hooks';
import { DirectoryItem, DirectoryGridResultsProps } from './types';
import { COMPACT_CARD_GRID_COLUMNS_CLASSES } from '@/constants/layout';
import { cn } from '@/lib/utils';

export function DirectoryGridResults<T extends DirectoryItem>({
    items,
    isItemSelected,
    isMultiSelectMode,
    deletingItemId,
    renderCard,
    skeletonComponent,
    messages,
    onLoadMore,
    isLoadingMore,
    hasMore,
    isInitialLoading,
    scrollContainer,
    gridClassName = cn('grid gap-4', COMPACT_CARD_GRID_COLUMNS_CLASSES),
    skeletonCount = 9,
}: DirectoryGridResultsProps<T>) {
    useInfiniteScroll(scrollContainer, {
        onLoadMore,
        isLoading: isLoadingMore,
        hasMore,
    });

    return (
        <GridLoadingState
            isLoading={isInitialLoading}
            isEmpty={items.length === 0}
            isLoadingMore={isLoadingMore}
            isReachingEnd={!hasMore}
            emptyMessage={messages.emptyMessage}
            loadingMoreMessage={messages.loadingMoreMessage}
            endMessage={messages.endMessage}
            skeletonComponent={skeletonComponent}
            skeletonCount={skeletonCount}
            gridClassName={gridClassName}
        >
            {items.map((item) => {
                const isSelected = isItemSelected(item);
                const isDeleting = deletingItemId === item.id;

                return renderCard(item, {
                    isSelected,
                    isDeleting,
                    isMultiSelectMode,
                });
            })}
        </GridLoadingState>
    );
}
